import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const kmbApi = {
  getTicketTransferInOutList: (request) => {
    const { params } = request
    return instance().get('api/ticket/kmb/transfer-in-out-list', {
      params
    })
  },
  putTransferMultiTicket: (request) => {
    const { data } = request

    const url = `api/ticket/kmb/transfer-multiple`
    return instance().put(url, data)
  },
  getAgentPerformance: (request) => {
    const { params } = request
    return instance().get('api/ticket/kmb/dashboard/agent-performance', {
      params
    })
  },
  getFollowUpTask: (request) => {
    const { params } = request
    return instance().get('api/follow-up-task/cms', {
      params
    })
  }
}
export default kmbApi



// WEBPACK FOOTER //
// ./src/api/kmb.js